var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"v-select-files",attrs:{"label":"title","options":_vm.fileListing},on:{"input":_vm.setSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }